import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import addressApi from "../api/addressApi";
// create slice

const name = "address";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const addressActions = { ...slice.actions, ...extraActions };
export const addressReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    lstAddress: [],
    totalCount: 0,
  };
}

function createExtraActions() {
  return {
    getShippingAddress: getShippingAddress(),
  };

  function getShippingAddress() {
    return createAsyncThunk(
      `${name}/getShippingAddress`,
      async (params) => await addressApi.getShippingAddress(params)
    );
  }
}

function createExtraReducers() {
  return {
    ...getShippingAddress(),
  };

  function getShippingAddress() {
    const { pending, fulfilled, rejected } = extraActions.getShippingAddress;
    return {
      [pending]: (state) => {
        // state.userSystems = { loading: true };
        state.lstAddress = [];
      },
      [fulfilled]: (state, action) => {
        state.lstAddress = action.payload?.results;
        state.totalCount = action.payload?.totalResults;
      },
      [rejected]: (state, action) => {
        // state.userSystems = { error: action.error };
        state.lstAddress = [];
      },
    };
  }
}
